module.exports = __webpack_public_path__ + "media/images/talent/mv-04-b990c3f5b6647d6d2bbdfdcf5bf2d115.png";